import React, { Component } from 'react';
import OverallStatistics from './OverallStatistics';
import MetricBarGraph from 'components/forecasts/MetricBarGraph';
import Titlebar from 'components/layouts/Titlebar';
import VisitorsChart from './VisitorsChart';
import MembersList from './MembersList';
import { Spin } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import { Row, Col } from 'react-flexbox-grid';
import { translate } from 'react-i18next';


class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.goalCrudService = props.goalCrudService;
        this.metricsCrudService = props.metricsCrudService;
        this.state = { revenues: [], loading: true, goal: this.props.goal };
    }

    async componentWillReceiveProps(nextProps) {
        this.setState({ loading: true });
        let goal = nextProps.goal;
        let revenues = this.state.revenues;
        if (!goal) {
            goal = await this.goalCrudService.get(goal);
        }
        revenues = await this.metricsCrudService.listRevenuesByGoal(goal);
        this.setState({ goal, revenues, loading: false });
    }

    async componentWillMount() {
        this.setState({ loading: true });
        let goal = this.state.goal;
        let revenues = this.state.revenues;
        if (!goal) {
            goal = await this.goalCrudService.get(this.state.goal);
        }
        revenues = await this.metricsCrudService.listRevenuesByGoal(goal);
        this.setState({ goal, revenues, loading: false });
    }

    getNearestRevenue() {
        return _.minBy(this.state.revenues, (metric) => metric.month.diff(moment()));
    }

    render() {
        return (
            <Spin spinning={this.state.loading}>            
            	<Titlebar title={this.props.t('dashboard.title')} description={this.props.t('dashboard.description')}/>
	            <Row>
					<Col md={12}>
						<OverallStatistics statistics={this.getNearestRevenue()} prefix={this.state.goal.currency}/>
					</Col>
					<Col md={5}>
						<VisitorsChart metrics={this.state.revenues} />
					</Col>
					<Col md={7}>
						<MetricBarGraph metrics={this.state.revenues} prefix={this.state.goal.currency}/>
					</Col>
                    <Col md={12}>
                        <MembersList goalId={this.state.goal.id} />
                    </Col>
				</Row>
			</Spin>
        );
    }
}

export default translate('translations')(Dashboard);


// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js